import React from "react";

import { utils } from "@rjsf/core";
import { FieldProps } from "@rjsf/core";
import { EvalutaionCheckWidget } from "../../jsonSchemaWidgets/EvaluationCheck/EvalutaionCheckWidget";
import { Header, List, Form } from "semantic-ui-react";
import { useSchemaTranslation } from "../../../../../sg-schema/useSchemaTranslation";

/*


    CURRENTLY HAS NO USE



*/

const EvaluationField: React.FC<FieldProps> = (props) => {
    const {
        schema,
        name,
        uiSchema,
        idSchema,
        formData,
        required,
        disabled,
        readonly,
        autofocus,
        onChange,
        onBlur,
        onFocus,
        registry = utils.getDefaultRegistry(),
        errorSchema,
    } = props;

    const { t } = useSchemaTranslation();
    const { title } = schema;
    const { widgets, formContext } = registry;
    let defaultWidget = EvalutaionCheckWidget;

    const options: any = utils.getUiOptions(uiSchema) || {};

    const { widget = defaultWidget, placeholder = "", header = {}, ...uiOptions } = options;

    const Widget = utils.getWidget(schema, widget, widgets);
    const text = options.title || schema.title || name;

    const rawErrors = props.rawErrors || (errorSchema["status"] && errorSchema["status"].__errors);
    const rawDescription = schema["description"] || uiSchema["description"] || uiSchema["ui:description"];
    const displayLabel = widget !== "checkbox" && props.label !== " ";
    console.log(name, { rawDescription, displayLabel, options, props });
    return (
        <Form.Field className="EvaluationField-container" error={Boolean(rawErrors)}>
            {text ? (
                <Header className="Field-label EvaluationField-label" as="label" {...(header as any)}>
                    {" "}
                    {t(text)}{" "}
                </Header>
            ) : null}

            {displayLabel && rawDescription ? <p>{t(rawDescription)}</p> : null}

            <Widget
                options={{ ...uiOptions }}
                schema={schema}
                id={idSchema && idSchema.$id}
                label={title === undefined ? name : title}
                value={formData}
                onChange={onChange}
                onBlur={onBlur}
                fieldKey={name}
                //@ts-ignore
                onFocus={onFocus}
                required={required}
                disabled={disabled}
                readonly={readonly}
                formContext={formContext}
                autofocus={autofocus}
                //@ts-ignore
                registry={registry}
                placeholder={placeholder ? t(placeholder) : placeholder}
                rawErrors={rawErrors}
                errorSchema={errorSchema["status"] || errorSchema}
            />

            {rawErrors && rawErrors.length > 0 && (
                <List>
                    {rawErrors.map((error: any, i: number) => (
                        <List.Item key={i}>
                            <span style={{ color: "#9F3A38" }}>{error}</span>
                        </List.Item>
                    ))}
                </List>
            )}
        </Form.Field>
    );
};

EvaluationField.defaultProps = {
    uiSchema: {},
    disabled: false,
    readonly: false,
    autofocus: false,
};

export default EvaluationField;
